interface CountryInfo {
  name: string;
  flag: string;
  limit: number;
  prefix: string;
}

interface Countries {
  [countryCode: string]: CountryInfo;
}

export const PhonenumberFields: Countries = {
  SA: {
    name: "Saudi Arabia",
    flag: "/assets/images/svg/saudi_flag.svg",
    limit: 9,
    prefix: "+966",
  },
};

export const removeSaudiPrefix = (number: string): string => {
  const prefix = "+966";

  if (number.startsWith(prefix)) {
    return number.slice(prefix.length);
  }

  return number;
};

export const isValidSaudiPhoneNumber = (phoneNumber: string): boolean => {
  // Regular expression for validating Saudi phone numbers (mobile only)
  const saudiPhoneRegex = /^(?:\+966|00966|966)?5\d{8}$/;

  // Remove spaces, dashes, and parentheses
  let cleanedPhoneNumber = `${phoneNumber}`.replace(/[\s-()]/g, "");

  // Remove leading 0 if present (local format)
  if (cleanedPhoneNumber.startsWith("0")) {
    cleanedPhoneNumber = cleanedPhoneNumber.substring(1);
  }

  // Check if it matches the Saudi phone number regex
  const isValid = saudiPhoneRegex.test(cleanedPhoneNumber);

  return isValid;
};

export function normalizeSaudiNumber(input: string): string {
  if (!input) return "";

  // Remove spaces and all non-digit chars except '+'
  let cleaned = input.replace(/\s+/g, "").replace(/[^\d+]/g, "");

  // Let user freely type the prefix without correction
  if (["+", "+9", "+96", "+966"].includes(cleaned)) {
    return cleaned;
  }

  // If user is still typing and input has fewer than 9 digits -> don't normalize yet
  const digitsOnly = cleaned.replace(/\D/g, "");
  if (digitsOnly.length < 9 && !cleaned.startsWith("+966")) {
    return cleaned;
  }

  // Normalize once we have a full number
  if (/^0\d{8,}$/.test(cleaned)) {
    cleaned = "+966" + cleaned.slice(1);
  } else if (/^966\d{8,}$/.test(cleaned)) {
    cleaned = "+" + cleaned;
  } else if (/^\d{8,}$/.test(cleaned)) {
    cleaned = "+966" + cleaned;
  }

  // Ensure no double prefix
  cleaned = cleaned.replace(/^\+\+966/, "+966");

  return cleaned;
}
